import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { Children, cloneElement, Fragment, isValidElement, memo, } from 'react';
import theme from '../../styles/theme';
import { sizes } from './constants';
const Spacing = ({ bottom, children, left, right, }) => (_jsx(ClassNames, { children: ({ css, cx, }) => {
        /* stylelint-disable */
        const getSpacing = (side, prop) => {
            if (!prop) {
                return null;
            }
            return css `
              margin-${side}: ${typeof prop === 'boolean' ? theme.spacing.x6 : sizes[prop]};
            `;
        };
        const bottomSpacing = getSpacing('bottom', bottom);
        const rightSpacing = getSpacing('right', right);
        const leftSpacing = getSpacing('left', left);
        return (_jsx(Fragment, { children: Children
                .map(children, (child) => (isValidElement(child)
                ? (cloneElement(child, {
                    className: cx(child.props.className, bottomSpacing && bottomSpacing, rightSpacing && rightSpacing, leftSpacing && leftSpacing),
                }))
                : null)) }));
    } }));
const MemoizedSpacing = memo(Spacing);
export { MemoizedSpacing as Spacing };
// MC-1068 Temporary hack for Storybook.
export default Spacing;
